import { useContext, useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Tabs, Tab, Snackbar, Alert, Modal, Box, CircularProgress, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import styles from "./Cadastro.module.css";
import { defaultValues, schema, camposPorAba } from "./ValidacoesSolicAcesso";
import servSolicitacaoAcesso from "../../../services/login/servSolicitacaoAcesso";
import servParam from "../../../services/login/servParam";
import { style as modalstyle } from "../../../components/Loading/Loading";
import { ErrorHandling } from "../../../components/Errors/Errors";
import TabPanel from "../../../components/Tabpanel/Tabpanel";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import { Interessado } from "./abas/Interessado";
import { Localizacao } from "./abas/Localizacao";
import { Geracao } from "./abas/Geracao";
import { Participantes } from "./abas/Participantes";
import { Equipamentos } from "./abas/Equipamentos";
import { VisualizarAnalise } from "./abas/ResultadoAnalise";
import { logout } from "../../../state/slices/userSlice";
import { OpcoesFases } from "../../../components/Combobox/Fases";
import { OpcoesModalidadeGD } from "../../../components/Combobox/ModalidadeGD";
import { OpcoesTipoRamal } from "../../../components/Combobox/TipoRamal";
import { OpcoesClassificacaoGeracao } from "../../../components/Combobox/ClassificacaoGeracao";
import { OpcoesTransformadorParticular } from "../../../components/Combobox/TransformadorParticular";
import { OpcoesTipoInstalacao } from "../../../components/Combobox/TipoInstalacao";
import { OpcoesTipoInscricao } from "../../../components/Combobox/TipoInscricao";
import { Documentos } from "./abas/Documentos";
import servAnalises from "../../../services/login/servAnalises";
import { OpcoesUF } from "../../../components/Combobox/UF";
import { formatarCnpj, formatarCpf } from "../../../infra/utils/FormataValores";
import { validarCnpj, validarCpf } from "../../../infra/utils/ValidacaoCpf";
import { format, parse } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { EquipamentoContext } from "../../../contexts/EquipamentoContext";
import { OpcoesTipoParticipacao } from "../../../components/Combobox/TipoParticipacao";
import Popup from "../../../components/Popup";
import EnviarSolicAnalise from "../EnviarSolicAnalise";
import servConsultaAcesso from "../../../services/login/servConsultaAcesso";

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Cadastro = ({
    setOpen,
    recordForEdit,
    setRecordForEdit,
    addOrEdit,
    pesquisar,
    novoCadastro,
    setEhNovoCadastro,
    tabResultadoAnalise,
    analisesDaSolic,
    recordForView
}) => {

    const methods = useForm({ mode: "onBlur", reValidateMode: "onChange", criteriaMode: 'all', defaultValues: defaultValues, resolver: yupResolver(schema) });
    const user = useSelector(state => state.user);
    const uc = useSelector(state => state.uc);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [tabIndex, setTabIndex] = useState(0);
    const [abasVisitadas, setAbasVisitadas] = useState(new Set([0]));
    const [podeSalvar, setPodeSalvar] = useState(true);

    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [typeAlert, setTypeAlert] = useState("error");
    const [isLoading, setIsLoading] = useState(false);

    const [analise, setAnalise] = useState(null);
    const [documentosObrigatorios, setDocumentosObrigatorios] = useState([]);

    const [goEquips, setGoEquips] = useState([]);
    const [goParticip, setGoParticip] = useState([]);

    const formatarEquipamentos = (equipamentosRec) => {
        if (equipamentosRec && equipamentosRec.length > 0) {
            let equipamentosFormatados = equipamentosRec.map((equipamento) => {
                equipamento.id = equipamento.Id;
                return equipamento;
            });
            setGoEquips(equipamentosFormatados);
        }
    }

    const isBotaoAcao = (event) => {
        if (!event?.nativeEvent?.submitter?.id) return false;
        const botoesAcao = ['salvarEquipamento', 'removerParticipante', 'ordenarParticipante', 'removerEquipamento', 'visualizarEquipamento'];
        return botoesAcao.includes(event.nativeEvent.submitter.id);
    }

    const [erroAoRecuperarConsumidor, setErroAoRecuperarConsumidor] = useState(false);
    const { equipamentoFoiEditado, setEquipamentoFoiEditado, equipamentoFoiEditadoRef } = useContext(EquipamentoContext);
    const [openDialog, setOpenDialog] = useState(false);

    const [isModalidadeGD, setIsModalidadeGD] = useState(false);

    const [unidadeConsumidora, setUnidadeConsumidora] = useState(false);
    const [potenciaInstalada, setPotenciaInstalada] = useState(0);

    const [anexosAnalise, setAnexosAnalise] = useState(null);

    const tabs =
        [
            { label: "Interessado", disabled: analisesDaSolic },
            { label: "Localização", disabled: analisesDaSolic },
            { label: "Projeto", disabled: analisesDaSolic },
            { label: "Equipamentos", disabled: analisesDaSolic },
            !isModalidadeGD && { label: "Participantes", disabled: analisesDaSolic },
            isModalidadeGD && recordForEdit && recordForEdit.Situacao == 0
                ? { label: "Documentos", disabled: analisesDaSolic }
                : { label: "Documentos", disabled: analisesDaSolic },
            isModalidadeGD
                ? recordForEdit && !novoCadastro && recordForEdit.Situacao !== 0 && { label: "Resultado" }
                : recordForEdit && !novoCadastro && recordForEdit.Situacao !== 0 && { label: "Resultado" },
        ].filter(Boolean);

    const lastTabIndex = tabs.length - 1;

    const commonTabStyles = {
        '&.Mui-disabled': {
            color: "#B8B8B8",
            borderBottom: "1px solid #B8B8B8",
        },
        color: "whitesmoke",
        borderBottom: "1px solid white",
    };
    const tabResultadoStyle = {
        '&.Mui-disabled': {
            color: "#B8B8B8",
            borderBottom: "1px solid white",
        },
        color: "whitesmoke",
        width: "60px",
        borderBottom: "1px solid white",
    };

    useEffect(() => {
        const situacoesBloqueadas = [1, 4, 5];

        const recuperarParticipantes = async () => {

            try {
                let id = analisesDaSolic ? recordForEdit[0].CodigoSolicitacao : recordForEdit.Id || recordForEdit.id;
                var data = await servSolicitacaoAcesso.RecuperarParaEditar(id);
                var docsObrigatorios = await servParam.RecuperarDocumentosObrigatorios(3);

                data = data.Content;
                docsObrigatorios = docsObrigatorios.Content;

                if (!data.CodigoUC) {
                    setUnidadeConsumidora(true);
                    methods.setValue("NovaUC", true);
                    methods.clearErrors("CodigoUC");
                } else {
                    setUnidadeConsumidora(false);
                    methods.setValue("NovaUC", false);
                }

                if (tabResultadoAnalise && data.ModalidadeGD != 4) {
                    setTabIndex(6);
                } else if (tabResultadoAnalise && data.ModalidadeGD == 4) {
                    setTabIndex(5);
                }


                mapearRetorno(data);
                mapearDocsObrigatorios(docsObrigatorios, data.Documentos);

                formatarParticipantes(data.Participantes);

                formatarEquipamentos(data.Equipamentos);

                verificaModalidadeGD(data);

                verificaCamposUc();
            } catch (err) {
                setIsLoading(false);
            }
        }

        const verificaCamposUc = async () => {
            if (!methods.getValues("CodigoUC") || !methods.getValues("Inscricao")) {
                return;
            }

            const situacoesBloqueadas = [1, 4, 5];

            if (situacoesBloqueadas.includes(recordForEdit?.Situacao)) return;

            let inscricao;

            if (methods.getValues("TipoInscricao")?.value == 1) {
                inscricao = formatarCpf(methods.getValues("Inscricao"));
                inscricao = inscricao.replaceAll("_", "");
            } else {
                inscricao = formatarCnpj(methods.getValues("Inscricao"));
            }

            if (inscricao < 11) {
                return
            }

            var dto = {
                CodigoUC: methods.getValues("CodigoUC"),
                Inscricao: inscricao
            };

            setErroAoRecuperarConsumidor(false);

            try {
                const data = await servSolicitacaoAcesso.RecuperarDadosDoConsumidor(dto);
            } catch (error) {
                setErroAoRecuperarConsumidor(true);
            }
        }

        const formatarParticipantes = (participantesRec) => {
            if (participantesRec && participantesRec.length > 0) {
                let participantesF = participantesRec.map((participante) => {
                    participante.id = participante.Id;
                    return participante;
                });

                setGoParticip(participantesF);
            }
        }

        const verificaModalidadeGD = (data) => {
            if (data.ModalidadeGD === 4) {
                setIsModalidadeGD(true);
            } else {
                setIsModalidadeGD(false);
            }
        }

        const recuperarUltimaAnalise = async () => {
            try {
                let id = analisesDaSolic ? recordForEdit[0].CodigoSolicitacao : recordForEdit.Id || recordForEdit.id;
                const data = await servAnalises.RecuperarUltimaAnaliseAcesso(id);

                let analise = data.Content[0];

                setAnalise(analise);

            } catch (err) {
                setIsLoading(false);
            }
        }

        const recuperarAnexosAnalise = async () => {
            try {
                let id;
                let dados;
        
                if (analisesDaSolic) {
                    id = recordForView?.Id;
                } else {
                    id = recordForEdit?.Id || recordForEdit?.id;
        
                    const data = await servAnalises.RecuperarUltimaAnaliseAcesso(id);
        
                    if (!data?.Content?.length) return;
        
                    const analise = data.Content[0];
        
                    if (!analise?.Id) return;
        
                    id = analise.Id;
                }
        
                if (!id) return;
        
                dados = await servAnalises.listarAnexos(id);
        
                setAnexosAnalise(dados?.Content || []);
            } catch (err) {
                console.error(err);
                setIsLoading(false);
            }
        };

        if (novoCadastro === false) {

            if (recordForEdit === null) return;

            setIsLoading(true);

            recuperarParticipantes();
            recuperarAnexosAnalise();

            if (recordForEdit.Situacao !== 0) {
                recuperarUltimaAnalise();
            }

            setIsLoading(false);

            if (situacoesBloqueadas.includes(recordForEdit.Situacao)) setPodeSalvar(false);
        } else {

            const recuperarDocumentosIniciais = async () => {
                try {
                    setIsLoading(true);

                    let response = await servParam.RecuperarDocumentosObrigatorios(3);

                    setDocumentosObrigatorios(response.Content);

                    methods.setValue('habilitaCodigoUC', true);

                    setIsLoading(false);
                } catch (err) {
                    setIsLoading(false);

                    setTypeAlert("error");

                    return ErrorHandling(
                        err?.request?.status,
                        err?.message,
                        setOpenError,
                        setErrorMessage,
                        dispatch,
                        logout,
                        navigate,
                        err?.response?.data?.Message
                    );
                }
            }

            const setarTipoGeracaoDefault = () => {
                methods.setValue("CodigoTipoGeracao", {
                    value: 3,
                    label: "UFV - Solar - Radiação solar"
                });
            }
            const setarTipoParticipacaoDefault = () => {
                methods.setValue("TipoParticipacao", {
                    value: 1,
                    label: "Porcentagem"
                });
            }

            recuperarDocumentosIniciais();
            setarTipoGeracaoDefault();

            setarTipoParticipacaoDefault();

        }
    }, [recordForEdit]);

    useEffect(() => {
        const recuperarEquipamentos = async () => {
            try {
                var data = await servSolicitacaoAcesso.RecuperarEquipamentosSolicCalculandoPotencia(methods.getValues("Id"));

                data = data.Content;

                setGoEquips([]);

                formatarEquipamentos(data);
            } catch (err) {
                console.log(err);
            }
        }

        if (equipamentoFoiEditado) {
            recuperarEquipamentos();
            setEquipamentoFoiEditado(false);
        }
    }, [equipamentoFoiEditado]);

    const retornaDadosConsumidor = async (data) => {
        try {
            let inscricaoFormatada = data.TipoInscricao?.value === 1 ? formatarCpf(data.Inscricao) : formatarCnpj(data.Inscricao),
                dto = {
                    CodigoUC: data.CodigoUC,
                    Inscricao: inscricaoFormatada
                };

            const response = await servSolicitacaoAcesso.RecuperarDadosDoConsumidor(dto);

            return Object.keys(response.Content).length > 0;
        } catch (error) {
            return false;
        }
    }

    const montarPayload = (data) => {
        return {
            Id: data.Id,
            CodigoResponsavelTec: user.codigoUsuario,
            CodigoSolicitacao: data.Id || 0,
            NovaUC: unidadeConsumidora ? 1 : 0,
            CodigoTipoGeracao: data?.CodigoTipoGeracao?.value ?? 1,
            TipoInscricao: data?.TipoInscricao?.value ?? 1,
            ClassificacaoGeracao: data?.ClassificacaoGeracao?.value ?? 1,
            ModalidadeGD: data?.ModalidadeGD?.value ?? 1,
            TipoConexao: data?.TipoConexao?.value ?? 1,
            TipoInstalacao: data?.TipoInstalacao?.value ?? 1,
            TipoRamal: data?.TipoRamal?.value ?? 1,
            TransformadorParticular: data?.TransformadorParticular?.value ?? 1,
            TipoParticipacao: data?.TipoParticipacao?.value ?? 1,
            Inscricao: data.TipoInscricao?.value === 1 ? formatarCpf(data.Inscricao) : formatarCnpj(data.Inscricao),
            Nome: data.Nome,
            FoneCelular1: data.FoneCelular1,
            FoneCelular2: data.FoneCelular2,
            Email: data.Email,
            Endereco: data.Endereco,
            CEP: data.CEP.replace("-", "").replaceAll("_", ""),
            Cidade: data.Cidade,
            Rua: data.Rua,
            NumeroEnd: data.NumeroEnd,
            Complemento: data.Complemento,
            UF: data?.UF?.value ?? " ",
            Longitude: data.Longitude,
            Latitude: data.Latitude,
            PotenciaInstalada: data.PotenciaInstalada,
            DisjustorUc: data.DisjustorUc,
            BitolaRamal: data.BitolaRamal,
            PercImpedanciaTransf: data.PercImpedanciaTransf,
            AreaArranjos: data.AreaArranjos,
            TipoLigacaoTransformador: data?.TipoLigacaoTransformador || " ",
            Armazenamento: data.Armazenamento,
            CodigoUC: data?.CodigoUC,
            Protocolo: data?.Protocolo,
        };
    };

    const salvarDados = async () => {
        try {
            const data = methods.getValues();

            if (data.TipoInscricao?.value === 1) {
                let cpf = formatarCpf(data.Inscricao);

                if (!validarCpf(cpf)) {
                    setTypeAlert("warning");
                    setErrorMessage("A inscrição informada é inválida");
                    setOpenError(true);
                    return false;
                }
            } else {
                let cnpj = formatarCnpj(data.Inscricao);

                if (!validarCnpj(cnpj)) {
                    setTypeAlert("warning");
                    setErrorMessage("A inscrição informada é inválida");
                    setOpenError(true);
                    return false;
                }
            }

            if (!unidadeConsumidora) {
                let contemDadosConsumidor = await retornaDadosConsumidor(data);

                if (!contemDadosConsumidor) {
                    setTypeAlert("warning");
                    setErrorMessage("Não foi encontrado consumidor com a combinação de UC e inscrição informadas.");
                    setOpenError(true);
                    return false;
                }
            }

            setIsLoading(true);

            if (data.Id === 0 && (data.CodigoUC === null || data.CodigoUC === " ")) {
                throw new Error("É necessário informar uma unidade consumidora");
            }

            const payload = montarPayload(data);

            const response = data.Id === 0
                ? await servSolicitacaoAcesso.Inserir(payload)
                : await servSolicitacaoAcesso.Editar(payload);

            if (data.Id === 0) {
                methods.setValue("Id", response.Content.Id);
            }

            setRecordForEdit(response.Content);
            mapearRetorno(response.Content);
            methods.reset({}, { keepValues: true });

            setTypeAlert("success");
            setOpenError(true);
            setErrorMessage(data.Id === 0 ? "Dados salvos com sucesso" : "Dados alterados com sucesso");

            pesquisar();

            return true;

        } catch (err) {
            setTypeAlert("error");

            ErrorHandling(
                err?.request?.status,
                err?.message,
                setOpenError,
                setErrorMessage,
                dispatch,
                logout,
                navigate,
                err?.response?.data?.Message
            );

            return false;
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmitSalvar = async (event) => {
        event.preventDefault();

        if (isBotaoAcao(event)) return;

        const abaValida = await validarAbaAtual(tabIndex);
        if (!abaValida) {
            setTypeAlert("warning");
            setErrorMessage("Existem campos inválidos ou obrigatórios não preenchidos. Verifique os campos destacados.");
            setOpenError(true);
            return;
        }

        await salvarDados();
    };

    const handleCadastroSolicAcesso = methods.handleSubmit(async (data, event) => {
        if (isBotaoAcao(event)) return;

        return await salvarDados();
    },

    (errors) => {
        const abaComErro = obterAbaDoErro(errors, isModalidadeGD);
        if (abaComErro !== null) {
            setTabIndex(abaComErro);
        }
        setTypeAlert("warning");
        setErrorMessage("Existem campos inválidos ou obrigatórios não preenchidos. Verifique os campos destacados.");
        setOpenError(true);
    });

    const obterAbaDoErro = (errors, isModalidadeGD) => {
        const nomesComErro = Object.keys(errors);
        for (let abaIdx = 0; abaIdx <= 6; abaIdx++) {
            const campos = camposPorAba[abaIdx] || [];
            if (campos.some(campo => nomesComErro.includes(campo))) {
                if (isModalidadeGD && abaIdx >= 4) return abaIdx - 1;
                return abaIdx;
            }
        }
        return null;
    };

    const validarAbaAtual = async (abaIdx) => {
        const camposDaAba = camposPorAba[abaIdx] || [];
        if (camposDaAba.length === 0) return true;
        const resultado = await methods.trigger(camposDaAba, {
            shouldFocus: true
        });
        return resultado;
    };

    const handleTabChange = async (event, newValue) => {
        const abaValida = await validarAbaAtual(tabIndex);
    
        if (!abaValida) {
            setTypeAlert("warning");
            setErrorMessage("Preencha corretamente os campos obrigatórios antes de avançar.");
            setOpenError(true);
            return;
        }
    
        if (podeSalvar) {
            const salvo = await salvarDados();
            if (!salvo) return;
        }

        setAbasVisitadas(prev => new Set([...prev, tabIndex]));
        setTabIndex(newValue);
    };
    

    const mapearRetorno = (data) => {
        methods.setValue("Protocolo", data.Protocolo);
        methods.setValue("TipoInscricao", {
            value: data.TipoInscricao,
            label: OpcoesTipoInscricao.find((opcao) => opcao.value == data.TipoInscricao).label
        });
        methods.setValue("Inscricao", data.Inscricao);
        methods.setValue("Nome", data.Nome);
        methods.setValue("FoneCelular1", data.FoneCelular1);
        methods.setValue("FoneCelular2", data.FoneCelular2);
        methods.setValue("Email", data.Email);
        methods.setValue("Endereco", data.Endereco);
        methods.setValue("CEP", data.CEP);
        methods.setValue("Cidade", data.Cidade);
        methods.setValue("Rua", data.Rua);
        methods.setValue("NumeroEnd", data.NumeroEnd);
        methods.setValue("Complemento", data.Complemento);
        methods.setValue("Longitude", data.Longitude);
        methods.setValue("Latitude", data.Latitude);
        methods.setValue("DataCadastro", data.DataCadastro);
        methods.setValue("PrazoAnalise", data.PrazoAnalise);
        methods.setValue("PossuiPrazoAdequacao", data.PossuiPrazoAdequacao);
        methods.setValue("PrazoAdequacao", data.PrazoAdequacao);
        methods.setValue("ModalidadeGD", {
            value: data.ModalidadeGD,
            label: OpcoesModalidadeGD.find((opcao) => opcao.value == data.ModalidadeGD).label
        });
        methods.setValue("TipoConexao", {
            value: data.TipoConexao,
            label: OpcoesFases.find((opcao) => opcao.value == data.TipoConexao).label
        });
        methods.setValue("PotenciaInstalada", data.PotenciaInstalada);
        setPotenciaInstalada(Number(data.PotenciaInstalada || 0));
        methods.setValue("DisjustorUc", data.DisjustorUc);
        methods.setValue("TipoRamal", {
            value: data.TipoRamal,
            label: OpcoesTipoRamal.find((opcao) => opcao.value == data.TipoRamal).label
        });
        methods.setValue("BitolaRamal", data.BitolaRamal);
        methods.setValue("ClassificacaoGeracao", {
            value: data.ClassificacaoGeracao,
            label: OpcoesClassificacaoGeracao.find((opcao) => opcao.value == data.ClassificacaoGeracao).label
        });
        methods.setValue("TipoInstalacao", {
            value: data.TipoInstalacao,
            label: OpcoesTipoInstalacao.find((opcao) => opcao.value == data.TipoInstalacao).label
        });
        methods.setValue("TransformadorParticular", {
            value: data.TransformadorParticular,
            label: OpcoesTransformadorParticular.find((opcao) => opcao.value == data.TransformadorParticular).label
        });
        methods.setValue("TipoLigacaoTransformador", data.TipoLigacaoTransformador?.trim() ?? " ");
        methods.setValue("PercImpedanciaTransf", data.PercImpedanciaTransf);
        methods.setValue("AreaArranjos", data.AreaArranjos);
        methods.setValue("Id", data.Id ? data.Id : data.CodigoSolicitacao);
        methods.setValue("CodigoResponsavelTec", data.CodigoResponsavelTec);
        methods.setValue("Armazenamento", data.Armazenamento);

        if (!unidadeConsumidora) {
            methods.setValue("CodigoUC", data.CodigoUC);
        }

        methods.setValue("TipoParticipacao", {
            value: data.TipoParticipacao,
            label: OpcoesTipoParticipacao.find((opcao) => opcao.value == data.TipoParticipacao).label
        });

        if (!data.TipoGeracao) {
            loadTipoGeracao(data.CodigoTipoGeracao);
        } else {
            methods.setValue("CodigoTipoGeracao", {
                value: data.CodigoTipoGeracao,
                label: data.TipoGeracao.Descricao
            });
        }

        if (data.UF.trim() !== "") {
            methods.setValue("UF", {
                value: data.UF,
                label: OpcoesUF.find((opcao) => opcao.value == data.UF).label
            });
        }
    }

    const loadTipoGeracao = async (codigoTipoGeracao) => {
        try {

            const response = await servConsultaAcesso.RecuperarTipoGeracao("");

            let data = response.Content.filter(tipoGeracao => tipoGeracao.Id === codigoTipoGeracao);

            return methods.setValue("CodigoTipoGeracao", {
                value: data[0].Id,
                label: data[0].Descricao
            });
        } catch (err) {
            setOpenError(true);
            setErrorMessage(err.response.data.Message);
        }
    }

    const mapearDocsObrigatorios = (docsObrigatorios, docsVinculados) => {
        docsObrigatorios.map((doc) => {
            if (docsVinculados.length) {
                for (let i = 0; i < docsVinculados.length; i++) {
                    if ((doc.Id == docsVinculados[i].CodigoConfigDoc) &&
                        (doc.CodigoClassificacaoDoc == docsVinculados[i].CodigoClassificacoDoc)) {
                        doc.CodigoDocumento = docsVinculados[i].CodigoDocumento;
                        doc.NomeArquivo = docsVinculados[i].NomeArquivo;
                        doc.Aprovado = docsVinculados[i].Aprovado;
                    }
                }
            }
        });

        setDocumentosObrigatorios(docsObrigatorios);
    }

    const proximaAba = async () => {
        const abaValida = await validarAbaAtual(tabIndex);
        if (!abaValida) {
            setTypeAlert("warning");
            setErrorMessage("Preencha corretamente os campos obrigatórios antes de avançar.");
            setOpenError(true);
            return;
        }
    
        if (podeSalvar) {
            const salvo = await salvarDados();
            if (!salvo) return;
        }

        setAbasVisitadas(prev => new Set([...prev, tabIndex]));
    
        const proximoIndice = tabIndex + 1;
    
        const isUltimaAba =
            (!isModalidadeGD && tabIndex === 6) ||
            (isModalidadeGD && tabIndex === 5) ||
            (!isModalidadeGD && novoCadastro && tabIndex === 5) ||
            (isModalidadeGD && novoCadastro && tabIndex === 4) ||
            (!isModalidadeGD && recordForEdit && recordForEdit.Situacao === 0 && tabIndex === 5) ||
            (isModalidadeGD && recordForEdit && recordForEdit.Situacao === 0 && tabIndex === 4);
    
        if (isUltimaAba) return setTabIndex(0);
    
        setTabIndex(proximoIndice);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenError(false);
        }

        setOpenError(false);
    }

    const fecharJanela = () => {
        setEhNovoCadastro(true);
        setOpen(false);
    }

    const handleClickOpenDialog = async (event, reason) => {
        try {
            await handleCadastroSolicAcesso();

            if (reason === 'clickaway') {
                setOpenDialog(true);
            }

            if (methods.getValues("TipoInscricao").value === 1) {
                let cpf = formatarCpf(methods.getValues("Inscricao"));

                if (!validarCpf(cpf)) {
                    setTypeAlert("warning");
                    setErrorMessage("A inscrição informada é inválida");
                    return setOpenError(true);
                }
            } else {
                let cnpj = formatarCnpj(methods.getValues("Inscricao"));

                if (!validarCnpj(cnpj)) {
                    setTypeAlert("warning");
                    setErrorMessage("A inscrição informada é inválida");
                    return setOpenError(true);
                }
            }

            setOpenDialog(true);
        } catch (err) {
            setOpenDialog(false);
            return setErrorMessage(err?.response?.data?.Message);
        }
    }

    const handleEnter = (event) => {
        if (event.keyCode === 13) {
            const form = event.target.form;
            const index = Array.prototype.indexOf.call(form, event.target);
            form.elements[index + 1].focus();
            event.preventDefault();
        }
    }

    const handleCloseDialog = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenDialog(false);
        }

        setOpenDialog(false);
    }

    const solicitarHomologacao = async () => {
        try {
            setIsLoading(true);

            await servAnalises.EnviarParaAnalise(methods.getValues("Id"))

            setOpenError(true);
            setErrorMessage("Solicitação de análise enviada com sucesso.");
            setIsLoading(false);

            setOpenDialog(false);

            setTimeout(() => {
                setOpen(false);
                pesquisar();
            }, [1400]);

        } catch (err) {
            setIsLoading(false);
            setOpenDialog(false);
            setOpenError(true);
            setTypeAlert("error");

            setErrorMessage(err?.response?.data?.Message);
            return setOpen(true);
        }
    }

    const handleBtnSolicitarAnalise = () => {
        const botaoSolicitarAnalise = (
            <BlueHoverButton onClick={handleClickOpenDialog} disabled={!podeSalvar}>
                Solicitar análise
            </BlueHoverButton>
        );

        if (tabIndex === lastTabIndex) {
            return botaoSolicitarAnalise;
        }
    }

    return (
        <div className={styles['modal-main']}>

            {methods.getValues("Id") !== 0 && (
                <div>
                    <header className={styles.header}>
                        <span className={styles.headerData}>
                            <div className={styles.dateBox}></div><b>Data de iní­cio: </b> {
                                format(parse(methods.getValues("DataCadastro"), 'dd/MM/yyyy HH:mm:ss', new Date()), "dd/MM/yyyy", {
                                    locale: ptBR
                                })
                            }
                        </span>

                        <span className={styles.headerData}>
                            <div className={`${styles.dateBox} ${styles['dateBox-green']}`}></div><b>Data prazo: </b>{
                                methods.getValues("PrazoAnalise") && (methods.getValues("PrazoAnalise").includes("01/01/1900") || methods.getValues("PrazoAnalise").includes("01/01/0001")) ?
                                    "Data ainda não definida" :
                                    format(parse(methods.getValues("PrazoAnalise"), 'dd/MM/yyyy HH:mm:ss', new Date()), "dd/MM/yyyy", {
                                        locale: ptBR
                                    })
                            }
                        </span>

                        {methods.getValues("PossuiPrazoAdequacao") === true && (
                            <span className={styles.headerData}>
                                <div className={`${styles.dateBox} ${styles['dateBox-orange']}`}></div><b>Prazo de adequação: </b>{
                                    format(parse(methods.getValues("PrazoAdequacao"), 'dd/MM/yyyy HH:mm:ss', new Date()), "dd/MM/yyyy", {
                                        locale: ptBR
                                    })
                                }
                            </span>
                        )}
                    </header>
                    <header className={styles.header}>
                        <span className={styles.headerData}>
                            <div className={`${styles.dateBox} ${styles['dateBox-darkblue']}`}></div><b>Orç. de conexão: </b> {methods.getValues("Id")}
                        </span>

                        {methods.getValues("Protocolo") && (
                            <span className={styles.headerData}>
                                <div className={`${styles.dateBox} ${styles['dateBox-gray']}`}></div><b>Protocolo: </b> {methods.getValues("Protocolo")}
                            </span>
                        )}
                    </header>
                </div>
            )}

            <FormProvider {...methods}>
                <form onSubmit={handleSubmitSalvar}>
                    <div className={styles.class100}>
                        <Box className={styles.boxTabs}>
                            <Tabs value={tabIndex}
                                onChange={handleTabChange}
                                aria-label="abas cadastro de solicitação">
                                <Tab sx={commonTabStyles} label="Interessado" {...a11yProps(0)} disabled={analisesDaSolic} />
                                <Tab sx={commonTabStyles} label="Localização" {...a11yProps(1)} disabled={analisesDaSolic} />
                                <Tab sx={commonTabStyles} label="Projeto" {...a11yProps(2)} disabled={analisesDaSolic} />
                                <Tab sx={commonTabStyles} label="Equipamentos" {...a11yProps(3)} disabled={analisesDaSolic} />
                                {!isModalidadeGD && <Tab sx={commonTabStyles} label="Participantes" {...a11yProps(4)} disabled={analisesDaSolic} />}
                                {isModalidadeGD && recordForEdit && recordForEdit.Situacao == 0 ?
                                    <Tab disabled={analisesDaSolic} sx={commonTabStyles} label="Documentos"  {...a11yProps(4)} />
                                    :
                                    <Tab sx={commonTabStyles} label="Documentos"  {...a11yProps(5)} disabled={analisesDaSolic} />
                                }
                                {isModalidadeGD ?
                                    recordForEdit && !novoCadastro && recordForEdit.Situacao !== 0 && <Tab sx={tabResultadoStyle} label="Resultado"  {...a11yProps(5)} />
                                    :
                                    recordForEdit && !novoCadastro && recordForEdit.Situacao !== 0 && <Tab sx={tabResultadoStyle} label="Resultado"  {...a11yProps(6)} />
                                }
                            </Tabs>
                        </Box>
                        <TabPanel value={tabIndex} index={0}>
                            <Interessado
                                situacaoSolic={recordForEdit && !novoCadastro ? recordForEdit.Situacao : 0}
                                desabilitarCamposSeHouverProtocoloGerado={methods.getValues("Protocolo")}
                                erroAoRecuperarConsumidor={erroAoRecuperarConsumidor}
                                setErroAoRecuperarConsumidor={setErroAoRecuperarConsumidor}
                                onKeyDown={handleEnter}
                                unidadeConsumidora={unidadeConsumidora}
                                setUnidadeConsumidora={setUnidadeConsumidora}
                                podeSalvar={podeSalvar}
                                uc={uc}
                            />
                        </TabPanel>
                        <TabPanel value={tabIndex} index={1}>
                            <Localizacao
                                setIsLoading={setIsLoading}
                                situacaoSolic={recordForEdit && !novoCadastro ? recordForEdit.Situacao : 0}
                                codigoUc={methods.getValues("CodigoUC")}
                                onKeyDown={handleEnter}
                                unidadeConsumidora={unidadeConsumidora}
                                podeSalvar={podeSalvar}
                            />
                        </TabPanel>
                        <TabPanel value={tabIndex} index={2}>
                            <Geracao
                                situacaoSolic={recordForEdit && !novoCadastro ? recordForEdit.Situacao : 0}
                                parecerProjeto={analise ? analise?.ParecerProjeto : 0}
                                parecerViabilidade={analise ? analise?.ParecerViabTecnica : 0}
                                onKeyDown={handleEnter}
                                isModalidadeGD={isModalidadeGD}
                                setIsModalidadeGD={setIsModalidadeGD}
                                goParticipantes={goParticip}
                                setParticipantes={setGoParticip}
                            />
                        </TabPanel>
                        <TabPanel value={tabIndex} index={3}>
                            <Equipamentos
                                codigoSolicitacao={methods.getValues('Id')}
                                setIsLoading={setIsLoading}
                                setOpenError={setOpenError}
                                setTypeAlert={setTypeAlert}
                                setErrorMessage={setErrorMessage}
                                setPotenciaInstalada={setPotenciaInstalada}
                                situacaoSolic={recordForEdit && !novoCadastro ? recordForEdit.Situacao : 0}
                                parecerEquipamentos={analise ? analise?.ParecerEquipamento : 0}
                                goEquips={goEquips}
                                setGoEquips={setGoEquips}
                                onKeyDown={handleEnter}
                            />
                        </TabPanel>
                        <TabPanel value={tabIndex} index={4}>
                            {!isModalidadeGD &&
                                <Participantes
                                    codigoSolicitacao={methods.getValues('Id')}
                                    setIsLoading={setIsLoading}
                                    setOpenError={setOpenError}
                                    setTypeAlert={setTypeAlert}
                                    setErrorMessage={setErrorMessage}
                                    parecerProjeto={analise ? analise?.ParecerProjeto : 0}
                                    situacaoSolic={recordForEdit && !novoCadastro ? recordForEdit.Situacao : 0}
                                    parecerViabilidade={analise ? analise?.ParecerViabTecnica : 0}
                                    goParticipantes={goParticip}
                                    setParticipantes={setGoParticip}
                                    onKeyDown={handleEnter}
                                    handleCadastroSolicAcesso={handleCadastroSolicAcesso}
                                    methods={methods}
                                    podeSalvar={podeSalvar}
                                />
                            }
                        </TabPanel>
                        <TabPanel value={tabIndex} index={isModalidadeGD ? 4 : 5}>
                            <Documentos
                                podeFazerUpload={podeSalvar}
                                codigoSolicitacao={methods.getValues('Id')}
                                documentos={documentosObrigatorios}
                                setIsLoading={setIsLoading}
                                setOpenError={setOpenError}
                                setErrorMessage={setErrorMessage}
                                potenciaInstalada={potenciaInstalada}
                                situacaoSolic={recordForEdit && !novoCadastro ? recordForEdit.Situacao || recordForEdit?.row?.Situacao : 0}
                                parecerDocumentos={analise ? analise?.ParecerDocumentos : 0}
                                tipoRamal={methods.getValues("TipoRamal").value}
                                modalidadeGD={methods.getValues("ModalidadeGD").value}
                                classificacaoGeracao={methods.getValues("ClassificacaoGeracao").value}
                                setTypeAlert={setTypeAlert}
                                unidadeConsumidora={unidadeConsumidora}
                            />
                        </TabPanel>
                        <TabPanel value={tabIndex} index={isModalidadeGD ? 5 : 6}>
                            <VisualizarAnalise
                                record={analise}
                                recordForView={recordForView}
                                anexos={anexosAnalise}
                            />
                        </TabPanel>
                    </div>
                    <div className={styles['solicitacao-botoes']} style={{ display: analisesDaSolic ? 'none' : 'flex' }}>
                        <BlueHoverButton type="submit" id="salvarSolicAcesso" name="salvarSolicAcesso" disabled={!podeSalvar}>
                            Salvar
                        </BlueHoverButton>
                        {handleBtnSolicitarAnalise()}
                        <BlueHoverButton onClick={proximaAba}>
                            {tabIndex == 0 ? (
                                <div>Informar localização</div>
                            ) : tabIndex == 1 ? (
                                <div>Informar dados do projeto</div>
                            ) : tabIndex == 2 ? (
                                <div>Informar equipamentos</div>
                            ) : tabIndex == 3 && !isModalidadeGD ? (
                                <div>Informar participantes</div>
                            ) : tabIndex == 3 && isModalidadeGD ? (
                                <div>Informar documentos</div>
                            ) : tabIndex == 4 && !isModalidadeGD ? (
                                <div>Informar documentos</div>
                            ) : tabIndex === 5 && !novoCadastro && !isModalidadeGD && (recordForEdit && recordForEdit.Situacao !== 0) ? (
                                <div>Visualizar resultado análise</div>
                            ) : tabIndex === 4 && !novoCadastro && isModalidadeGD && (recordForEdit && recordForEdit.Situacao !== 0) ? (
                                <div>Visualizar resultado análise</div>
                            ) : (
                                <div>Informar dados do interessado</div>
                            )}
                        </BlueHoverButton>
                        <BlueHoverButton onClick={fecharJanela} >
                            Cancelar
                        </BlueHoverButton>
                    </div>
                </form>
            </FormProvider>

            <Snackbar open={openError} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={typeAlert} sx={{ width: "100%" }}>
                    {errorMessage}
                </Alert>
            </Snackbar>
            <Modal open={isLoading}>
                <Box style={modalstyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
            <Popup title="Enviar orçamento para análise" openPopup={openDialog} setOpenPopup={setOpenDialog} minHeight="100px" >
                <EnviarSolicAnalise
                    setOpenPopup={setOpenDialog}
                    recordForEdit={recordForEdit}
                    codeSolAcesso={methods.getValues("Id")}
                    codeRespTecnico={methods.getValues("CodigoResponsavelTec")}
                    pesquisar={pesquisar}
                    setOpen={setOpen}
                />
            </Popup>
        </div>
    );
}

export { Cadastro };